import { useMemo } from 'react';

import ReportCard from 'components/charts/ReportCard';

import useAccessControl from 'hooks/useAccessControl';

import PATHS from 'utils/paths';

import * as S from '../Reports/Reports.styled';

/**
 * @author Burak Ak
 */

const BranchReports = () => {
	const isAuthorized = useAccessControl();

	const branchReports = useMemo(
		() => [
			{
				title: 'branchReports',
				subTitle: 'branchReportsSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.BRANCH_REPORT,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true
					}
				]
			},
			{
				title: 'branchDailyStaffReport',
				subTitle: 'branchDailyStaffReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.BRANCH_DAILY_STAFF_REPORT,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true
					}
				]
			}
		],
		[]
	);

	return (
		<S.Container className="row row-cols-1 row-cols-lg-2">
			{branchReports
				.filter((item) => isAuthorized(item.actionPath))
				.map((item, index) => (
					<ReportCard
						key={index}
						title={item.title}
						subTitle={item.subTitle}
						actionPath={item.actionPath}
						actionLabel={item.actionLabel}
						filterArray={item.filterArray}
					/>
				))}
		</S.Container>
	);
};

export default BranchReports;
